import { put, takeLeading } from "redux-saga/effects";
import { FETCH_HEDATA_LOGS_LIST_REQUESTED } from "../HeDataLogs";
import { CHARTS_SET_DATA_SOURCE, CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES } from "../Diagramme"

function* getSelectedDataSource(action) {
	if(action.data_source_index === CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES) {
		yield put({type: FETCH_HEDATA_LOGS_LIST_REQUESTED});
	}
}

export function* watchConfigChartsSetDataSource() {
	yield takeLeading(CHARTS_SET_DATA_SOURCE, getSelectedDataSource);
}